(() => {
  const OPENING_DATE = '2026-12-01';
  const STORAGE_KEY = 'zagaraBookingSearch:v1';
  const HANDLER_KEY = '__zagaraPreviewHomeSubmitHandler';

  function sitePath(path) {
    const root = window.Shopify?.routes?.root || '/';
    const prefix = root === '/' ? '' : root.replace(/\/$/, '');
    return `${prefix}${path}`;
  }

  function isHomePage() {
    return Boolean(document.querySelector('[id^="ZagaraHero-"]'));
  }

  function parseIsoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return null;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setHours(0, 0, 0, 0);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) return null;
    return date;
  }

  function formatIsoDate(date) {
    const pad = (number) => String(number).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }

  function addDays(value, days) {
    const date = parseIsoDate(value);
    if (!date) return '';
    date.setDate(date.getDate() + days);
    return formatIsoDate(date);
  }

  function writeSearch(searchData) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchData));
    } catch (error) {
      /* Il passaggio via URL continua a funzionare. */
    }
  }

  function adaptPropertyCards() {
    document.querySelectorAll('.zagara-property-card').forEach((card) => {
      const name = card.querySelector('.zagara-property-card__name, .zagara-property-card__title');
      const currentName = name?.textContent.trim();
      const isViaRoma =
        currentName === 'Zagara Centro' ||
        currentName === 'Zagara Via Roma' ||
        card.classList.contains('zagara-property-card--centro');

      if (!isViaRoma) return;
      if (name) name.textContent = 'Zagara Via Roma';

      const status = card.querySelector('.zagara-property-card__status');
      if (status) status.textContent = 'Soggiorni dal 1 dicembre 2026';

      const badge = card.querySelector('.zagara-property-card__badge');
      if (badge && /coming soon/i.test(badge.textContent)) badge.remove();

      card.classList.remove('zagara-property-card--coming-soon');
    });
  }

  function syncViaRomaDateMinimum(form) {
    const property = form.querySelector('[name="property"]');
    const checkin = form.querySelector('[name="checkin"]');
    const checkout = form.querySelector('[name="checkout"]');
    if (!property || !checkin || !checkout) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayValue = formatIsoDate(today);
    const minCheckin =
      property.value === 'centro' && OPENING_DATE > todayValue
        ? OPENING_DATE
        : todayValue;

    checkin.min = minCheckin;
    checkout.min =
      checkin.value && parseIsoDate(checkin.value)
        ? addDays(checkin.value, 2)
        : addDays(minCheckin, 2);
  }

  function adaptHero() {
    const hero = document.querySelector('[id^="ZagaraHero-"]');
    if (!hero) return;

    const form = hero.querySelector('[data-booking-form]');
    const property = form?.querySelector('[name="property"]');
    const option = property?.querySelector('option[value="centro"]');
    if (option) option.textContent = 'Zagara Via Roma';

    if (form && property && form.dataset.zagaraViaRomaPreviewReady !== 'true') {
      form.dataset.zagaraViaRomaPreviewReady = 'true';
      property.addEventListener('change', () => syncViaRomaDateMinimum(form));
      form.querySelector('[name="checkin"]')?.addEventListener('change', () => {
        window.setTimeout(() => syncViaRomaDateMinimum(form), 0);
      });
    }

    if (form) syncViaRomaDateMinimum(form);
  }

  function adaptViaRomaHomeSection() {
    const target = document.querySelector('#zagara-centro');
    if (!target) return;

    const heading = target.querySelector('.zagara-centro__heading');
    if (heading) heading.innerHTML = 'Zagara<br>Via Roma';

    target.querySelector('.zagara-centro__coming-soon')?.remove();

    const description = target.querySelector('.zagara-centro__description');
    if (description) {
      description.innerHTML =
        '<p>In Via Roma 59, Zagara Via Roma ti porta nel cuore autentico di Palermo, tra arte, cultura, mercati storici, sapori e tradizioni.</p>';
    }

    const notifyTitle = target.querySelector('.zagara-centro__notify-copy strong');
    const notifyText = target.querySelector('.zagara-centro__notify-copy span');
    if (notifyTitle) notifyTitle.textContent = 'Soggiorni dal 1 dicembre 2026';
    if (notifyText) notifyText.textContent = 'Scopri la struttura, gli spazi e i servizi disponibili.';

    const button = target.querySelector('.zagara-centro__button');
    if (button) {
      button.href = sitePath('/pages/zagara-centro');
      button.removeAttribute('target');
      button.removeAttribute('rel');
      const label = button.querySelector('span');
      if (label) label.textContent = 'Scopri Zagara Via Roma';
    }

    const badge = target.querySelector('.zagara-centro__round-badge strong');
    if (badge) badge.textContent = 'VIA ROMA';

    target.querySelectorAll('img[alt]').forEach((image) => {
      if (image.alt.includes('Zagara Centro')) {
        image.alt = image.alt.replaceAll('Zagara Centro', 'Zagara Via Roma');
      }
    });
  }

  function adaptHomeFaq() {
    document.querySelectorAll('.zagara-faq__item').forEach((item) => {
      const question = item.querySelector('.zagara-faq__question');
      if (!question || question.textContent.trim() !== 'Zagara Centro è già prenotabile?') return;

      question.textContent = 'Da quando è possibile soggiornare a Zagara Via Roma?';
      const answer = item.querySelector('.zagara-faq__answer .rte');
      if (answer) {
        answer.innerHTML =
          '<p>I soggiorni a Zagara Via Roma, in Via Roma 59, saranno disponibili a partire dal 1 dicembre 2026. Il calendario dedicato sarà attivato sul sito ufficiale.</p>';
      }
    });
  }

  function adaptHomeReviews() {
    const score = document.querySelector('.zagara-reviews__score-value strong');
    if (score) score.textContent = '8';
  }

  function adaptFinalBooking() {
    const form = document.querySelector('[data-zagara-final-booking]');
    if (!form) return;

    form.dataset.bookingUrl = sitePath('/pages/zagara-mondello');
    const metaItems =
      form.closest('.zagara-final-booking__card')?.querySelectorAll('.zagara-final-booking__meta > span');
    if (metaItems?.[1]) {
      const icon = metaItems[1].querySelector('svg');
      metaItems[1].textContent = 'Prenotazione diretta sul sito ufficiale';
      if (icon) metaItems[1].prepend(icon);
    }
  }

  function adaptBookingPicker() {
    const picker = document.querySelector('[data-zagara-booking-picker]');
    if (!picker) return;

    const intro = picker.querySelector('.zagara-booking-picker__intro');
    if (intro) intro.textContent = 'Scegli la struttura e continua sul nostro sito ufficiale.';

    const viaRomaChoice = picker.querySelectorAll('[data-zagara-booking-choice]')[1];
    if (viaRomaChoice) {
      viaRomaChoice.href = sitePath('/pages/zagara-centro#disponibilita');
      const detail = viaRomaChoice.querySelector('small');
      if (detail) detail.textContent = 'Via Roma 59 · Palermo · dal 1 dicembre 2026';
    }
  }

  function adaptFooter() {
    const footer = document.querySelector('.zagara-footer');
    if (!footer) return;

    footer.querySelectorAll('.zagara-footer__column a').forEach((link) => {
      const text = link.textContent.trim();

      if (text === 'Zagara Centro') {
        link.textContent = 'Zagara Via Roma';
      }

      if (text === 'Prenota ora') {
        link.href = sitePath('/pages/zagara-mondello#disponibilita');
        link.removeAttribute('target');
        link.removeAttribute('rel');
      }
    });

    const address = footer.querySelector('.zagara-footer__contact--static > span:last-child');
    if (address) {
      address.textContent = address.textContent.replaceAll('Zagara Centro', 'Zagara Via Roma');
    }

    const cta = footer.querySelector('.zagara-footer__cta-button');
    if (cta) {
      cta.href = sitePath('/pages/zagara-mondello#disponibilita');
      cta.removeAttribute('target');
      cta.removeAttribute('rel');
    }
  }

  function handleCapturedSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isHomePage()) return;

    if (form.matches('[data-booking-form]')) {
      const property = form.querySelector('[name="property"]');
      if (!property || property.value !== 'centro') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const checkin = form.querySelector('[name="checkin"]');
      const checkout = form.querySelector('[name="checkout"]');
      const guests = form.querySelector('[name="guests"]');
      if (!checkin || !checkout || !guests || !form.reportValidity()) return;

      if (!parseIsoDate(checkin.value) || checkin.value < OPENING_DATE) {
        const error = form.querySelector('[data-booking-error]');
        if (error) {
          error.textContent = 'Zagara Via Roma accoglie soggiorni dal 1 dicembre 2026.';
          error.hidden = false;
        }
        checkin.focus();
        return;
      }

      const minimumCheckout = addDays(checkin.value, 2);
      if (!parseIsoDate(checkout.value) || checkout.value < minimumCheckout) {
        const error = form.querySelector('[data-booking-error]');
        if (error) {
          error.textContent = 'Per il soggiorno sono richieste almeno 2 notti.';
          error.hidden = false;
        }
        checkout.focus();
        return;
      }

      const guestCount = Number(guests.value);
      if (!Number.isInteger(guestCount) || guestCount < 1 || guestCount > 6) return;

      const searchData = {
        check_in: checkin.value,
        check_out: checkout.value,
        guests: guestCount
      };
      writeSearch(searchData);

      const destination = new URL(sitePath('/pages/zagara-centro'), window.location.origin);
      destination.searchParams.set('check_in', searchData.check_in);
      destination.searchParams.set('check_out', searchData.check_out);
      destination.searchParams.set('guests', String(searchData.guests));
      destination.hash = 'disponibilita';
      window.location.assign(destination.toString());
      return;
    }

    if (form.matches('[data-zagara-final-booking]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.reportValidity()) return;

      const checkin = form.querySelector('[name="checkin"]');
      const checkout = form.querySelector('[name="checkout"]');
      const adults = form.querySelector('[name="group_adults"]');
      const children = form.querySelector('[name="group_children"]');
      if (!checkin || !checkout || !adults || !children) return;

      const minimumCheckout = addDays(checkin.value, 2);
      if (!parseIsoDate(checkin.value) || !parseIsoDate(checkout.value) || checkout.value < minimumCheckout) {
        checkout.setCustomValidity('Per il soggiorno sono richieste almeno 2 notti.');
        checkout.reportValidity();
        window.setTimeout(() => checkout.setCustomValidity(''), 0);
        return;
      }

      const totalGuests = (Number(adults.value) || 0) + (Number(children.value) || 0);
      if (!Number.isInteger(totalGuests) || totalGuests < 1 || totalGuests > 6) return;

      const searchData = {
        check_in: checkin.value,
        check_out: checkout.value,
        guests: totalGuests
      };
      writeSearch(searchData);

      const destination = new URL(sitePath('/pages/zagara-mondello'), window.location.origin);
      destination.searchParams.set('check_in', searchData.check_in);
      destination.searchParams.set('check_out', searchData.check_out);
      destination.searchParams.set('guests', String(searchData.guests));
      destination.hash = 'disponibilita';
      window.location.assign(destination.toString());
    }
  }

  function applyAll() {
    adaptBookingPicker();
    adaptFooter();

    if (!isHomePage()) return;

    adaptPropertyCards();
    adaptHero();
    adaptViaRomaHomeSection();
    adaptHomeFaq();
    adaptHomeReviews();
    adaptFinalBooking();
  }

  if (window[HANDLER_KEY]) {
    document.removeEventListener('submit', window[HANDLER_KEY], true);
  }
  window[HANDLER_KEY] = handleCapturedSubmit;
  document.addEventListener('submit', window[HANDLER_KEY], true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  window.setTimeout(applyAll, 350);
  window.setTimeout(applyAll, 1000);
  document.addEventListener('shopify:section:load', () => window.setTimeout(applyAll, 0));
})();